import React from 'react';

import './Program.detail.trackerEntry.scss';

export default function TrackerEntry({vital}) {
    if(!vital){
        return '';
    }

    const renderSvgByType = () => {
        if (vital.value === 'SPO2') {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                    <path fill="#2299F9" d="M15.221 7.892c-4.047 0-7.329 3.282-7.329 7.33 0 4.047 3.282 7.328 7.33 7.328 4.047 0 7.328-3.281 7.328-7.329-.006-4.045-3.284-7.322-7.329-7.329zm0 13.53c-3.425 0-6.201-2.776-6.201-6.2 0-3.426 2.776-6.202 6.201-6.202s6.201 2.776 6.201 6.201c-.006 3.423-2.778 6.195-6.2 6.202zM10.148 5.075C10.148 2.272 7.876 0 5.074 0S0 2.272 0 5.074s2.272 5.073 5.074 5.073c2.8-.006 5.067-2.274 5.074-5.073zM5.074 9.02c-2.18 0-3.946-1.767-3.946-3.946 0-2.18 1.766-3.947 3.946-3.947S9.02 2.894 9.02 5.074 7.253 9.02 5.074 9.02zm10.711-2.255c1.868 0 3.383-1.514 3.383-3.383C19.168 1.514 17.652 0 15.785 0s-3.383 1.514-3.383 3.382c0 1.869 1.515 3.383 3.383 3.383zm0-5.638c1.245 0 2.255 1.01 2.255 2.255 0 1.246-1.01 2.255-2.255 2.255-1.245 0-2.255-1.01-2.255-2.255 0-1.245 1.01-2.255 2.255-2.255z"/>
                </svg>
            )
        } else if (vital.value === 'HR') {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="23" viewBox="0 0 29 23">
                  <path fill="#2199F9" d="M28.376 10.114h-2.548c.62-2.779.338-5.102-.84-6.905C23.326.66 20.495.131 20.376.11L20.36.108c-3.506-.542-5.239 1.068-6.032 2.303-.795-1.234-2.529-2.843-6.046-2.3-.12.02-2.95.55-4.615 3.098-1.188 1.82-1.465 4.167-.823 6.984.01.043.05.203.127.457H.617c-.34 0-.617.28-.617.625 0 .346.276.626.617.626h2.808c1.09 2.666 3.964 7.783 10.667 10.601.076.032.156.048.237.048.08 0 .16-.016.236-.048 7.182-3.02 9.97-8.679 10.875-11.136h2.936c.34 0 .617-.28.617-.626s-.276-.626-.617-.626zm-24.33-.208c-.56-2.457-.344-4.473.643-5.993 1.362-2.1 3.784-2.565 3.793-2.567.41-.064.79-.092 1.14-.092 3.353 0 4.077 2.622 4.108 2.742.07.278.316.473.599.473.282 0 .529-.196.598-.473.034-.136.874-3.32 5.24-2.651.124.024 2.45.497 3.793 2.556.993 1.521 1.212 3.541.652 5.999-.002.007-.02.082-.06.214h-10.78c-.275 0-.517.185-.593.452l-.706 2.482-1.16-6.601c-.048-.27-.264-.478-.532-.511-.269-.033-.528.114-.638.365l-1.925 4.348H4.28c-.162-.457-.232-.73-.235-.743zm10.283 11.339c-5.686-2.477-8.389-6.812-9.54-9.344h3.828c.243 0 .464-.144.563-.369l1.27-2.868 1.274 7.252c.05.287.289.5.575.515l.033.001c.273 0 .516-.183.592-.452l1.311-4.614h9.868c-.992 2.41-3.648 7.21-9.774 9.879z"/>
              </svg>
            )
        }else{
            return '';
        }
    }

    const getVitalLabel = () => {
        return vital.label;
    }

    return (
        <div className="trackerItem">
            <div className="trackerTitle">
                <span className="_iconSvg">
                    {renderSvgByType()}
                </span>
                <span className="title">{getVitalLabel()}</span>
            </div>
            <div className="trackerSubtitle">
                {vital.shortDescription? vital.shortDescription : ''}
            </div>
            <div className="descriptionItems">
                {
                    vital.descriptionItems && vital.descriptionItems.map((item, index) => (
                        <div key={index} className="row">
                            <div className="label">{ item.key? item.key+':':'' }</div>
                            <div className="value">{item.value}</div>
                        </div>
                    ))
                }
            </div>
            {
                vital.tableItems?
                    <div className={"tableItems col-"+vital.tableItems.head.length}>
                        <div className="_title">{ vital.tableItems.label }</div>
                        <div className="head">
                            {
                                vital.tableItems.head.map((item, index) => (
                                    <div key={index} className="label">{item}</div>
                                ))
                            }
                        </div>
                        {
                            vital.tableItems.rows.map((row, index) => (
                                <div className="row">
                                    {
                                        row.map((item, index_) => (
                                            <div key={index_}>{item}</div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>: ''
            }
        </div>
    )
}